<div class="relative z-10" role="dialog">
  <div *ngIf="isOpen" @backdrop class="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"></div>
  <div *ngIf="isOpen" @open class="fixed inset-0 z-10 w-screen overflow-y-auto p-4 sm:p-6 md:p-20">
    <div
      (clickOutside)="resetSearch(false)"
      class="mx-auto max-w-2xl transform divide-y divide-gray-500 divide-opacity-10 overflow-hidden rounded-xl bg-white bg-opacity-80 shadow-2xl ring-1 ring-black ring-opacity-5 backdrop-blur backdrop-filter transition-all">
      <div class="relative">
        <div class="pointer-events-none absolute left-4 top-3.5 h-5 w-5 text-gray-900 text-opacity-40">
          <svg class="h-5 w-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <use xlink:href="#icon-search"></use>
          </svg>
        </div>
        <input
          #searchInputRef
          (keyup)="onSearch($event)"
          class="h-12 w-full border-0 bg-transparent pl-12 pr-4 text-gray-900 focus:ring-0 sm:text-sm"
          placeholder="Rechercher..."
          type="text" />
      </div>
      <ul class="max-h-80 scroll-py-2 divide-y divide-gray-500 divide-opacity-10 overflow-y-auto">
        <li *ngIf="isSearching; else isNotSearching" class="p-2">
          <ul class="text-sm text-gray-700">
            <ng-container *ngIf="results.length; else noResults">
              <ng-container *ngFor="let result of results">
                <li
                  (click)="onClickResult(result.url)"
                  *ngIf="result.url"
                  class="group flex select-none items-center rounded-md px-3 py-3 cursor-pointer hover:bg-gray-900 hover:bg-opacity-5 hover:text-gray-900">
                  <span class="flex-auto truncate">{{ result.label | firstCase }}</span>
                </li>
              </ng-container>
            </ng-container>
            <ng-template #noResults>
              <li class="group flex select-none items-center px-3 py-3">
                <span class="flex-auto truncate">Aucun résultats...</span>
              </li>
            </ng-template>
          </ul>
        </li>
        <ng-template #isNotSearching>
          <li *ngIf="commonSearches && commonSearches.length" class="p-2">
            <h2 class="mb-2 mt-4 px-3 text-xs font-semibold text-gray-900">Recherches populaires</h2>
            <ul class="text-sm text-gray-700">
              <ng-container *ngFor="let commonSearch of commonSearches">
                <li
                  (click)="onClickResult(commonSearch.url)"
                  *ngIf="commonSearch.url"
                  class="group flex select-none items-center rounded-md px-3 py-2 cursor-pointer hover:bg-gray-900 hover:bg-opacity-5 hover:text-gray-900">
                  <span class="flex-auto truncate">{{ commonSearch.label | firstCase }}</span>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
</div>
